import { formatMoney } from "./money";

function MonthlyTotalBar({
  variant = "view",
  total,
  planAmount,
  addonsAmount,
  periodLabel = "/mo",
  onCancel,
  onSave,
  isSaving = false,
  isSaveDisabled = false,
}) {
  if (variant === "view") {
    return (
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-5 border border-blue-100">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Total</p>
            <p className="text-2xl font-bold text-gray-900">
              {total != null ? `$${formatMoney(total)}` : "—"}
              <span className="text-sm font-normal text-gray-500">{periodLabel}</span>
            </p>
          </div>
          <div className="text-right text-sm text-gray-500">
            <p>Plan: {planAmount != null ? `$${formatMoney(planAmount)}` : "—"}</p>
            <p>Add-ons: {addonsAmount != null ? `$${formatMoney(addonsAmount)}` : "—"}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-shrink-0 border-t border-gray-200 bg-white">
      <div className="px-5 py-3 flex items-center justify-between">
        <div className="flex items-baseline gap-2">
          <span className="text-sm text-gray-500">Total</span>
          <span className="text-xl font-bold text-gray-900">${formatMoney(total)}</span>
          <span className="text-xs text-gray-400">{periodLabel}</span>
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center justify-center gap-2 font-medium rounded-lg transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 active:bg-gray-100 px-4 py-2 text-sm"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSave}
            disabled={isSaving || isSaveDisabled}
            className="inline-flex items-center justify-center gap-2 font-medium rounded-lg transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:cursor-not-allowed bg-gray-800 text-white hover:bg-gray-600 active:bg-gray-700 disabled:bg-gray-300 disabled:text-gray-500 px-5 py-2 text-sm"
          >
            {isSaving ? (
              <>
                <svg
                  className="animate-spin w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                </svg>
                Saving...
              </>
            ) : (
              "Save Changes"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default MonthlyTotalBar;